import { Modal, Typography } from 'antd';
import DataTable from './DataTable';

const { Title } = Typography;

export default function TableModal({ isOpen, onClose, data, onItemSelect }) {
  return (
    <Modal
      title={<Title level={4} style={{ margin: 0 }}>Gestión de Documentos y Proyectos</Title>}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      width="80%"
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto', padding: '1.5rem' } }}
    >
      <DataTable data={data} onItemSelect={onItemSelect} />
    </Modal>
  );
}
